/* Gallery and variant tiers adapted from the existing product buy box.
   Shopify owns prices. Every purchase surface submits one native product form. */
(() => {
  let dispose = () => {};
  function initialize() {
    dispose();
    const root = document.querySelector('[data-ld-pdp-root]');
    if (!root) return;
    const controller = new AbortController();
    const { signal } = controller;
    const observers = [];
    const galleryData = document.querySelector('[data-ld-gallery-assets]');
    if (false && galleryData) {
      try {
        const assets = JSON.parse(galleryData.textContent);
        const slides = [...root.querySelectorAll('[data-vshbb-slide]')];
        const thumbs = [...root.querySelectorAll('[data-vshbb-thumb]')];
        assets.forEach((asset, index) => {
          const slideImage = slides[index]?.querySelector('img');
          const thumbImage = thumbs[index]?.querySelector('img');
          if (slideImage) {
            slideImage.src = asset.src;
            slideImage.srcset = '';
            slideImage.alt = asset.alt;
          }
          if (thumbImage) {
            thumbImage.src = asset.src;
            thumbImage.srcset = '';
            thumbImage.alt = asset.alt;
          }
        });
      } catch (error) {
        console.warn('LymphDrops gallery assets could not be loaded.', error);
      }
    }
    const pageAssetData = document.querySelector('[data-ld-page-assets]');
    if (pageAssetData) {
      try {
        const pageAssets = JSON.parse(pageAssetData.textContent);
        document.querySelectorAll('.ld-placeholder__label').forEach(label => {
          const key = label.textContent.replace(/^\[IMAGE PLACEHOLDER —\s*/, '').replace(/\]$/, '').trim();
          const asset = pageAssets.placeholders[key] || (key === 'LymphDrops' ? pageAssets.gallery?.[1] : null);
          if (!asset) return;
          const image = document.createElement('img');
          image.src = asset.src;
          image.alt = asset.alt;
          image.loading = 'lazy';
          image.decoding = 'async';
          label.closest('.ld-placeholder')?.replaceWith(image);
        });
        const emptyGallery = document.querySelector('.vshgal-empty');
        if (emptyGallery && pageAssets.gallery?.length) {
          const grid = document.createElement('div');
          grid.className = 'vshgal-grid vshgal-grid--even';
          pageAssets.gallery.forEach(asset => {
            const figure = document.createElement('figure');
            figure.className = 'vshgal-tile vshgal-tile--normal';
            const media = document.createElement('div');
            media.className = 'vshgal-media';
            const image = document.createElement('img');
            image.src = asset.src;
            image.alt = asset.alt;
            image.loading = 'lazy';
            image.decoding = 'async';
            media.append(image);
            figure.append(media);
            grid.append(figure);
          });
          emptyGallery.replaceWith(grid);
        }
      } catch (error) {
        console.warn('LymphDrops page assets could not be loaded.', error);
      }
    }
    const form = root.querySelector('.ld-pdp-form');
    const radios = [...root.querySelectorAll('[data-offer-radio]')];
    const status = root.querySelector('[data-pdp-status]');
    const unavailable = status.textContent;
    const sticky = document.querySelector('[data-pdp-sticky]');
    const stickyButton = sticky?.querySelector('[data-pdp-sticky-add]');
    const mainButton = root.querySelector('[data-pdp-add]');
    const final = document.querySelector('[data-pdp-final-offers]');
    const information = document.querySelector('.ld-pdp-info')?.closest('section');
    const informationMarker = information ? document.createComment('ld-pdp-information-origin') : null;
    if (informationMarker) information.before(informationMarker);
    function placeInformation() {
      if (!information || !informationMarker) return;
      const inline = matchMedia('(min-width: 900px)').matches;
      information.classList.toggle('ld-pdp-information-inline', inline);
      if (inline) root.querySelector('.ld-pdp-buy-copy').append(information);
      else informationMarker.after(information);
    }
    placeInformation();
    window.addEventListener('resize', placeInformation, {signal});
    let submitting = false;
    const countdown = root.querySelector('[data-offer-countdown]');
    // A transparent daily countdown: refreshing the page never restarts it.
    function nextMidnight() {
      const end = new Date();
      end.setHours(24, 0, 0, 0);
      return end.getTime();
    }
    let deadline = nextMidnight();
    function tick() {
      if (!countdown) return;
      const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      if (seconds <= 0) deadline = nextMidnight();
      countdown.hidden = !Number.isFinite(deadline);
      if (countdown.hidden) return;
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      for (const [unit,value] of Object.entries({hours:Math.floor(remaining/3600),minutes:Math.floor(remaining/60)%60,seconds:remaining%60})) {
        countdown.querySelector('[data-timer-'+unit+']').textContent=String(value).padStart(2,'0');
      }
    }
    tick();
    const timerId = Number.isFinite(deadline) ? setInterval(tick,1000) : null;
    function selected() { return radios.find(radio => radio.checked); }
    function sync() {
      const radio = selected();
      if (!radio) return;
      const available = radio.dataset.available === 'true';
      const detail = root.querySelector('[data-selected-offer]');
      if (detail) detail.textContent = radio.dataset.title + ' · ' + radio.dataset.bottles + (radio.dataset.bottles === '1' ? ' Bottle' : ' Bottles');
      form.elements.id.value = available ? radio.dataset.variant : '';
      form.elements.quantity.value = radio.dataset.quantity;
      mainButton.disabled = !available || submitting;
      root.querySelector('[data-pdp-button-price]').textContent = radio.dataset.price ? '— ' + radio.dataset.price : '';
      status.textContent = available ? '' : unavailable;
      radios.forEach(item => item.closest('.vshbb-ob-tier').classList.toggle('is-active', item === radio));
      if (sticky) {
        sticky.querySelector('[data-pdp-sticky-title]').textContent = radio.dataset.bottles + (radio.dataset.bottles === '1' ? ' Bottle' : ' Bottles') + ' · ' + radio.dataset.title;
        sticky.querySelector('[data-pdp-sticky-price]').textContent = radio.dataset.price || 'Available soon';
        stickyButton.disabled = !available || submitting;
      }
    }
    const defaultRadio = radios.find(radio => radio.dataset.available === 'true') || radios[0];
    if (!selected() && defaultRadio) defaultRadio.checked = true;
    root.addEventListener('change', sync, {signal});
    sync();
    if (final) {
      final.replaceChildren();
      radios.forEach(radio => {
        const button = document.createElement('button');
        button.type = 'button';
        const title = document.createElement('strong');
        title.textContent = radio.dataset.title;
        const price = document.createElement('span');
        price.textContent = radio.dataset.price || 'Available soon';
        button.append(title, price);
        if (radio.closest('.ld-pdp-featured')) {
          const badge = document.createElement('small');
          badge.textContent = 'MOST POPULAR';
          button.append(badge);
        }
        button.addEventListener('click', () => {
          radio.checked = true;
          sync();
          radio.focus({preventScroll:true});
          root.querySelector('#offers').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
        }, {signal});
        final.append(button);
      });
    }
    form.addEventListener('submit', event => {
      const radio = selected();
      if (!radio || radio.dataset.available !== 'true' || submitting) { event.preventDefault(); return; }
      // Deliberately native submission: no client-calculated discounts or checkout redirects.
      submitting = true;
      mainButton.disabled = true;
      if (stickyButton) stickyButton.disabled = true;
      status.textContent = 'Adding your selected offer…';
    }, {signal});
    window.addEventListener('pageshow', () => { submitting = false; sync(); }, {signal});
    stickyButton?.addEventListener('click', () => form.requestSubmit(), {signal});
    const track = root.querySelector('[data-vshbb-track]');
    const slides = [...track.querySelectorAll('[data-vshbb-slide]')];
    const thumbs = [...root.querySelectorAll('[data-vshbb-thumb]')];
    thumbs.forEach((button,index) => button.addEventListener('click', () => {
      track.scrollTo({left:slides[index].offsetLeft - slides[0].offsetLeft, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant':'smooth'});
    }, {signal}));
    track.addEventListener('scroll', () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((button,i) => button.setAttribute('aria-pressed', String(index === i)));
    }, {signal, passive:true});
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      track.scrollBy({left:track.clientWidth * (event.key === 'ArrowRight' ? 1 : -1), behavior:'smooth'});
    }, {signal});
    document.querySelectorAll('[data-pdp-carousel]').forEach(carousel => {
      const section = carousel.closest('section');
      section.querySelector('[data-carousel-prev]')?.addEventListener('click', () => carousel.scrollBy({left:-carousel.clientWidth,behavior:'smooth'}), {signal});
      section.querySelector('[data-carousel-next]')?.addEventListener('click', () => carousel.scrollBy({left:carousel.clientWidth,behavior:'smooth'}), {signal});
    });
    document.querySelectorAll('[data-pdp-play]').forEach(button => button.addEventListener('click', () => {
      const media = button.closest('[data-vshugc-media]');
      const fragment = media.querySelector('template').content.cloneNode(true);
      media.replaceChildren(fragment);
      media.querySelector('video')?.play().catch(() => {});
    }, {signal}));
    if (sticky) {
      const spacer = document.querySelector('[data-pdp-sticky-spacer]');
      const refresh = () => {
        sticky.hidden = root.getBoundingClientRect().bottom > 0;
        if (spacer) spacer.style.height = sticky.hidden ? '0px' : `${sticky.offsetHeight + 16}px`;
        document.documentElement.style.setProperty('--ld-pdp-sticky-height', `${sticky.offsetHeight + 16}px`);
      };
      const observer = new IntersectionObserver(refresh, {threshold:0});
      observer.observe(root);
      observers.push(observer);
      const sizeObserver = new ResizeObserver(refresh);
      sizeObserver.observe(sticky);
      observers.push(sizeObserver);
      window.addEventListener('scroll',refresh,{signal,passive:true});
      refresh();
    }
    dispose = () => { clearInterval(timerId); controller.abort(); observers.forEach(observer => observer.disconnect()); document.documentElement.style.removeProperty('--ld-pdp-sticky-height'); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', initialize);
})();
